import { render, staticRenderFns } from "./CoapEventSourceUpdateDialog.vue?vue&type=template&id=2f67a5e7&"
import script from "./CoapEventSourceUpdateDialog.vue?vue&type=script&lang=ts&"
export * from "./CoapEventSourceUpdateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports